module.exports = __webpack_public_path__ + "static/scale-model-of-the-sea-lab-in-torrance-california-5e98e3c8c220579b01176a3117022381.png";